import { render, staticRenderFns } from "./TableBlueLabelCount.vue?vue&type=template&id=389909ca&scoped=true&"
import script from "./TableBlueLabelCount.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelCount.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelCount.vue?vue&type=style&index=0&id=389909ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389909ca",
  null
  
)

export default component.exports